import React from 'react';
import { theme } from '../../../../tailwind.config';
import { IIconProps } from 'ui/CircleIconButton';

export const KpiTriangleUpIcon: React.FC<IIconProps> = React.memo(({ className = '', icon = 'brown-100' }) => (
  <svg
    width="8"
    height="5"
    viewBox="0 0 8 5"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M7.32793 5H0.67293C0.0745384 5 -0.224657 4.22478 0.197572 3.77282L3.52507 0.211015C3.78792 -0.0703382 4.21295 -0.0703382 4.47299 0.211015L7.8005 3.77282C8.22552 4.22478 7.92633 5 7.32793 5Z"
      fill={theme.colors[icon]}
    />
  </svg>
));
